module.exports = parcelRequire.resolve("jtl1M");